import * as Config from "@/config";
import * as Common from "@/utils/common";
import {ProjectCategory} from "@/stores/project";

export function useAttributes() {
  /**
   * 属性画面 - エリアの表示
   * @param {ProjectCategory} projectCategory 選択されているProjectCategory
   * @returns {boolean} エリア非表示フラグ
   */
  const isHiddenArea = (projectCategory: ProjectCategory | undefined): boolean => {
    if (!projectCategory) return false;
    const isDrmApply = Config.DRM_APPLY_CATEGORY_IDS.includes(projectCategory.id)
    return projectCategory.category_code === Config.CATEGORY_CODE_FAQ ||
      projectCategory.category_code === Config.CATEGORY_CODE_INFORMATION ||
      projectCategory.category_code === Config.CATEGORY_CODE_APPROVAL ||
      isDrmApply;
  }

  /**
   * 属性画面 - ブロックの表示
   * @param {ProjectCategory} projectCategory 選択されているProjectCategory
   * @returns {boolean} ブロック非表示フラグ
   */
  const isHiddenBlock = (projectCategory: ProjectCategory | undefined): boolean => {
    if (!projectCategory) return false;
    return projectCategory.id === Config.PROJECT_CATEGORY_ID_BASIC_MAP || isHiddenArea(projectCategory)
  }

  return {isHiddenArea, isHiddenBlock}
}